import React, { useState } from 'react'
import './styles.scss'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'
import { CardInfoUserChannel } from 'components/Sidemenu/SideMenuInChat/components'
import ModalChannelView from 'components/Sidemenu/SideMenuInChat/Containers/ChannelsContainer/ModalChannelView'
import { apiInchat } from 'api'

const PluginContactInformation = ( { conversation = {} } ) => {

  const [openModalView, setOpenModalView] = useState(false)

  const handleToggle = () => {
    setOpenModalView(prevState => !prevState)
  }

  const conversationAction = async (body) => {
    try {
      const resp = await apiInchat.actionConversation(body)
      return resp.data
    } catch (error) {
      throw new Error(error)
    }
  }

  const renderSection = (conversation) => {
    const { type, createdBy, usersInfo } = conversation

    switch (type) {
      case 'direct': {
        const user = usersInfo ? usersInfo.filter(it => it._id !== createdBy) : []
        return <CardInfoUserChannel inInfo user={user[0]} className={'inchat-plugin-contact-information__pressed'} />
      }
      case 'group':
      case 'channel':
        return  (
          <div className="inchat-plugin-contact-information__avatar-stack">
            {usersInfo.map(({ picture, _id }, index) => {
              if(index > 4) return null
              return(
                <img
                  key={_id}
                  src={picture}
                  alt={`Avatar ${_id}`}
                  onError={event => {
                    event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
                    event.onerror = null
                  }}
                />
              )}
            )}
            <span className='inchat-plugin-contact-information__avatar-stack--text'>{usersInfo.length} {usersInfo && usersInfo.length > 1 ? lang('dashboard_members') : lang('dashboard_member')}</span>
          </div>
        )
      default:
        return <div></div>
    }
  }

  return (
    <div
      onClick={handleToggle}
      className='inchat-plugin-contact-information'
    >
      {renderSection(conversation)}
      <ModalChannelView
        isOpenModal={openModalView}
        toggleOpen={handleToggle}
        conversationAction={conversationAction}
        conversation={conversation || {}}
      />
    </div>
  )
}

export default PluginContactInformation